import keyMirror from "keymirror";

export default keyMirror({
  USER_SET_LANG_WILL_SET: null,
  USER_SET_LANG_DID_SET: null,
});
